module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-ons-page')
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f6c33720","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/login-form/LoginPage.vue
// module id = 722
// module chunks = 1